import {CookiePolicyCloseESB} from "@next/eventservice"

const closedESB = new CookiePolicyCloseESB()

export const PublishCookiePolicyClose = () => {
    closedESB.publish()
}

export const SubscribeCookiePolicyClose = (cb: () => void) => {
    return closedESB.subscribe(cb)
}
